'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdSettingsBackupRestore = function MdSettingsBackupRestore(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20 5q6.3 0 10.6 4.4t4.4 10.6-4.4 10.6-10.6 4.4q-5.2 0-9.1-3.1l2.3-2.4q3.1 2.1 6.8 2.1 4.8 0 8.2-3.4t3.4-8.2-3.4-8.2-8.2-3.4-8.2 3.4-3.4 8.2h5l-6.8 6.6-6.6-6.6h5q0-6.2 4.4-10.6t10.6-4.4z m3.4 15q0 1.3-1.1 2.3t-2.3 1.1-2.3-1.1-1.1-2.3 1.1-2.3 2.3-1.1 2.3 1.1 1.1 2.3z' })
        )
    );
};

exports.default = MdSettingsBackupRestore;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/settings-backup-restore.js
// module id = 1433
// module chunks = 36573943044255 79611799117203 213534597649335